<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Job Information</h3>
       </template>
                                                                                                                                                                                                                                        
       <div class="row">
          <nav>
             <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link to="/hr/jobinformation">&nbsp;Active Employees</router-link>
               </li>
               <li class="breadcrumb-item active">Inactive Employees</li>
             </ol>
          </nav>
       </div>
       <hr style="margin-top:-10px"/>
             <div class="row">
                <div class="col-md-5">
                   <p><i class="fa fa-search"></i> Search Employee</p>
                   <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
                </div>
                <div class="col-md-3">
                   <div class="form-group">
                      <p><i class="fa fa-filter"></i>&nbsp;Filter by Position:</p>
                      <select v-model="filter_by_position" class="form-control" required>
                         <option value="">Default</option>
                         <option v-for="pos in positions"  v-text="pos.pos_name"></option>
                      </select>
                   </div>
                </div>
                <div class="col-md-1">
                   <div class="form-group">
                      <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                      <select v-model="order_by" class="form-control" required>
                         <option value="">Default</option>
                         <option value="-1">ASC</option>
                         <option value="1">DESC</option>
                      </select>
                   </div>
                </div>
                <div class="col-md-1">
                   <div class="form-group">
                      <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                      <select v-model="page_limit" class="form-control" required>
                         <option value="">Default</option>
                         <option value="5">5</option>
                         <option value="10">10</option>
                         <option value="25">25</option>
                         <option value="50">50</option>
                         <option value="100">100</option>
                         <option value="500">500</option>
                      </select>
                   </div>
                </div>
                <div class="col-md-2">
                   <div class="form-group">
                      <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                      <select v-model="filter_by_status" class="form-control" required>
                         <option value="">Default</option>
                         <option value="regular">regular</option>
                         <option value="probationary">probationary</option>
                         <option value="promoted">promoted</option>
                         <option value="trainee">trainee</option>
                         <option value="terminated">terminated</option>
                         <option value="resigned">resigned</option>
                         <option value="awol">AWOL</option>
                      </select>
                   </div>
                </div>
             </div>
             <hr>
             <!-- PAGINATION -->
                <b-pagination
                v-model="curentPage"
                :total-rows="items.length"
                :per-page="perPage"
                aria-controls="my-table"
                align="right"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                ></b-pagination>
             <!-- END PAGINATION -->
             <hr>
             <div class="table-responsive ">
                <table class="table table-striped table-hover "  v-loading="loading">
                   <thead>
                      <tr>
                         <th>Id</th>
                         <th>Employee</th>
                         <th>Designation</th>
                         <th>Basic Salary</th>
                         <th>Allowance</th>
                         <th><i class="fa fa-calendar"></i>Joined Date</th>
                         <th><i class="fa fa-calendar"></i>Date Signed</th>
                         <th>Status</th>
                         <th>Action</th>
                      </tr>
                   </thead>
                   <tbody>
                      <tr v-for="item , i in computedJobInformation" >
                            <template v-if="item === 'no data found'">
                               <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                            </template>   
                            <template v-else>
                                <td>{{i+1}}</td>
                                <td> {{item.full_name | capitalize}}</td>
                                <td>{{item.position_name}}</td>
                                <td><span>&#8369;</span>{{formatMoney(item.basic_salary)}}</td>
                                <td><span>&#8369;</span>{{formatMoney(item.monthly_allowance)}}</td>
                                <td>
                                    <span v-if="item.employment_date !== null"> {{ getDate(item.employment_date)}}</span>
                                    <span v-else>-------------------</span>    
                                </td>
                                <td>
                                    <span v-if="item.date_signed !== null"> {{ getDate(item.date_signed)}}</span>
                                    <span v-else>-------------------</span>      
                                </td>
                                <td>
                                    <span v-if="item.status == 'probationary'">
                                    <i class="fa fa-flag text-info"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'trainee'">
                                    <i class="fa fa-flag text-warning"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'regular'">
                                    <i class="fa fa-flag text-success"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'promoted'">
                                    <i class="fa fa-flag text-secondary"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'resigned'">
                                    <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'terminated'">
                                    <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                                    </span>
                                    <span v-else-if="item.status == 'awol'">
                                    <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                                    </span>
                                </td>
                                <td>
                                    <router-link :to="{name: 'view-job-information', params: { id: item.id }}" class="btn btn-xs btn-default"><i class="fa fa-eye"></i>View</router-link>
                                    <!-- <a href="#" class="btn btn-sm btn-info" @click="get_selected_id(item)" v-b-modal.view-job-information v-b-tooltip.hover title="View Full Details"><i class="fa fa-eye"></i></a>  -->
                                    <a href="#"  class="btn btn-xs btn-default" @click="get_selected_id(item)" v-b-modal.update-job-information><i class="fa fa-pencil"></i>Update</a>
                                </td>
                            </template>    
                      </tr>
                   </tbody>
                </table>
             <!-- PAGINATION NATIVE WAY -->
                  <div class="row">
                    <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                    </div>
                    <div class="col-md-6">
                      <b-pagination
                          v-model="curentPage"
                          :total-rows="items.length"
                          :per-page="perPage"
                          aria-controls="my-table"
                          align="right"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"
                      ></b-pagination>
                    </div>
                 </div>
                 <!-- END PAGINATION -->
                <!-- MODAL FOR VIEW RECORD -->
                <b-modal id="view-job-information" ref="hide-modal-job-information"  size="xl"   title="Update Item"  hide-footer>
                   <h3>{{selected_user.first_name | capitalize}}, {{selected_user.last_name | capitalize}}</h3>
                   <div class="row">
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Employment  Date:</label>
                            <p v-if="selected_user.employment_date !== null">
                               {{getDate(selected_user.employment_date)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Date Signed:</label>
                            <p v-if="selected_user.date_signed !== null">
                               {{getDate(selected_user.date_signed)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Resignation Date:</label>
                            <p v-if="selected_user.regularization_date !== null">
                               {{getDate(selected_user.regularization_date)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Promoted Date:</label>
                            <p v-if="selected_user.promoted_date !== null">
                               {{getDate(selected_user.promoted_date)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Training Date:</label>
                            <p v-if="selected_user.training_date !== null">
                               {{getDate(selected_user.training_date)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Regularization Date:</label>
                            <p v-if="selected_user.regularization_date !== null">
                               {{getDate(selected_user.regularization_date)}}
                            </p>
                            <p v-else>N/A</p>
                         </div>
                      </div>
                      <div class="col-md-4">
                      </div>
                   </div>
                </b-modal>
                <!-- MODAL FOR UPDATE RECORD  -->
                <b-modal id="update-job-information" ref="hide-modal-job-information"  size="l"   title="Update Status"  hide-footer>
                   <h3>{{selected_user.full_name | capitalize}}</h3>
                   <hr/>
                   <div class="row">
                      <div class="col-md-12">
                         <div class="form-group">
                            <label>Employment Status:</label>
                            <select  class="form-control" v-model="selected_user.status">
                               <option value="trainee">Trainee</option>
                               <option value="probationary">Probationary</option>
                               <option value="regular">Regular</option>
                               <option value="promoted">Promoted</option>
                               <option value="terminated">Terminated</option>
                               <option value="resigned">Resigned</option>
                               <option value="awol">AWOL</option>
                            </select>
                         </div>
                         <i>You can update or change the employee status based on the selection.</i><br/><br/>
                      </div>
                   </div>
                   <hr/>
                   <div class="form-group">
                      <button class="btn btn-info float-right" @click="update_job_information"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                   </div>
                   <br/> <br/>
                </b-modal>
             </div>
       <!-- If Lost Connection on Server -->   
         <template v-if="display_indicator === 1">
                <center>
                    <br/><br/>
                    <img  src="/static/img/warning.png"  width="225" height="190">
                <h1>You've lost your network connection</h1>
                <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                <br/><br/>
            </center>
         </template>
    </card>
 </template>
<script>  
/* eslint-disable */ 
import Card from 'src/components/UIComponents/Cards/Card.vue' 
export default {
components: {
  Card
},
data() {
  return {
     items: [],
     positions: [],
     selected_user: '',
     search: '',
     filter_by_position: '',
     filter_by_status: '',
     order_by: '',
     //pagination
     page_limit: '',
     start_page: 1,
     display_indicator: '',
     loading: true,
     //PAGINATION
     perPage: 20,
     curentPage:1
  }
},
mounted: function() {
  this.get_jobinformation();
  this.get_positions();

},
methods: {
   
formatMoney(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
 },  

  current_change: function (currentPage) {
     this.currentPage = currentPage;
  },
  get_jobinformation() {
     axios.get('api/inactive')
        .then(response => {
           this.items = response.data;
           
           this.loading = false;
           this.display_indicator = 2;
        })
        .catch(e => {
           console.log(e.response)
           this.display_indicator = 1;
        })
  },
  get_positions() {
     axios.get('api/positions')
        .then(response => {
           this.positions = response.data;
        })
        .catch(e => {
           console.log(e.response)
        })
  },
 
  get_selected_id(item) {
     this.selected_user = item;
  },

  update_job_information(e) {
     e.preventDefault();
     axios.post('api/jobinformation/update/inactive/' + this.selected_user.id, { 
           'resignation_date': "NULL",
           'status': this.selected_user.status,
        })
        .then(resp => {      
             if(resp.data.response == 'success'){
                this.$swal({
                    type: 'success',
                    title: 'Updated',
                    text: resp.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                this.$refs['hide-modal-job-information'].hide()
                this.get_jobinformation()
             }else if(resp.data.response == 'error'){
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: resp.data.message,
                    showConfirmButton: true,
                    timer: 2000
                })
             } 

        })
        .catch(error => {
           if (error.response.status == 422) {
              let d = error.response.data
              console.log("response =>".d);
           }
        })
  }


},

computed: {

  // PAGINATION
  offset() {  return (this.start_page - 1) * this.page_limit; },
  limit() { return this.offset + this.page_limit; },   
  total_item(){ return this.items.length }, 

  computedJobInformation() {
    let filtered = this.items
    // USE IN PAGINATION 
    let start = (this.curentPage-1) * this.perPage
    let end = this.curentPage * this.perPage
    filtered = filtered.slice(start, end)

      if(filtered.length > 0){
        // SEARCH BY EMPLOYEE FULLNAME
        if (this.search) {
        filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
        );
        return filtered
        }
        // FILTER BY POSITION
        if (this.filter_by_position) {
        filtered = filtered.filter(
            item => item.position_name.toLowerCase() === this.filter_by_position.toLowerCase()
        );
        return filtered
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
        filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
        return filtered
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
        filtered = filtered.slice(this.offset, this.limit);
        return filtered
        }
        // FILTER BY STATUS
        if (this.filter_by_status) {
        filtered = filtered.filter(
            item => item.status.toLowerCase() === this.filter_by_status.toLowerCase()
        );
        return filtered
        }
      }
     return filtered
  }
},

}
</script>
<style>
.position{
    color :#ebebeb;
}
    
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/todo-inactive.vue